export enum routes {
  Login = '/login',
  Actions = '/actions',
}
